import { render, staticRenderFns } from "./PopupCustomProperty.vue?vue&type=template&id=fc017d34&"
import script from "./PopupCustomProperty.vue?vue&type=script&lang=ts&"
export * from "./PopupCustomProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports